import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Multiselect } from 'react-widgets';
import typeOf from '../../helpers/typeOf';

const Custom = ({ segment: propSegment, values: propValues, onChange: propOnChange }) => {
    const [segment, setSegment] = useState(propSegment);
    const [values, setValues] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const parseData = useCallback((values) => {
        if (!values || !Array.isArray(values)) return [];
        
        if (values.length && !typeOf.isObject(values[0])) {
            return values.map((item) => ({ value: item, title: item }));
        } else if (typeOf.isObject(values[0]) && !values[0].title) {
            return values.map((item) => ({ value: item.value, title: item.value }));
        }

        return values;
    }, []);

    useEffect(() => {
        setSegment(propSegment);
        setValues(parseData(propValues || []));
    }, [propSegment, propValues, parseData]);

    const onChange = useCallback((newValues) => {
        setValues(newValues);
        if (propOnChange) {
            propOnChange(newValues);
        }
    }, [propOnChange]);

    const onCreate = useCallback((value) => {
        const newValues = [...values, { value, title: value }];
        setValues(newValues);
        if (propOnChange) {
            propOnChange(newValues);
        }
    }, [values, propOnChange]);

    const onSearch = useCallback((searchTerm) => {
        setSearchTerm(searchTerm);
    }, []);

    const messageCreateOption = useCallback((inputValue) => {
        return `Create "${inputValue}"`;
    }, []);

    return (
        <Multiselect
            dataKey="value"
            textField="title"
            value={Array.isArray(values) ? values : []}
            data={Array.isArray(values) ? values : []}
            onChange={onChange}
            onCreate={onCreate}
            onSearch={onSearch}
            allowCreate
            filter={false}
            placeholder="Type to create..."
            messages={{ createOption: messageCreateOption }}
        />
    );
};

Custom.propTypes = {
    segment: PropTypes.string,
    values: PropTypes.array,
    onChange: PropTypes.func
};

Custom.defaultProps = {
    segment: '',
    values: [],
    onChange: () => {}
};

export default Custom;